<script setup lang="ts">

type Props = {
    isBuilder?: boolean;
    upgradeLink?: string,
    isMobile?: boolean,
}

withDefaults(defineProps<Props>(), {
	isBuilder: false,
	isMobile: false,
});

const websiteBuilderLink = 'https://www.hostinger.com/website-builder';

</script>

<template>
	<div
		class="upgrade-banner"
		:style="{ gap: isMobile ? '24px' : '62px' }"
	>
		<div class="upgrade-banner__message">
			<svg
				class="upgrade-banner__icon"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M2.50011 7.59134V1.57321L5.53752 3.19282V5.90428L9.55844 5.90622L12.6451 7.59134H2.50011ZM10.3807 5.40809V1.573L13.5
                    3.15231V7.22014L10.3807 5.40809ZM10.3807 12.7637V10.0757L6.32874 10.0729C6.33252 10.0907 3.19083 8.3608 3.19083
                    8.3608L13.5 8.40918V14.4272L10.3807 12.7637ZM2.5 12.7637L2.50011 8.83102L5.53752 10.6002V14.3429L2.5 12.7637Z"
					fill="#673DE6"
				/>
			</svg>
			<p class="upgrade-banner__text">
				Powered by
				<a
					v-qa="'upgrade-banner-link'"
					class="upgrade-banner__link"
					:href="websiteBuilderLink"
					rel="noopener"
					title="Hostinger Website Builder"
					target="_blank"
				>
					Hostinger Website Builder
				</a>
			</p>
		</div>

		<a
			v-if="isBuilder && upgradeLink"
			v-qa="'upgrade-banner-link-button'"
			class="upgrade-banner__link-button"
			:href="upgradeLink"
			rel="noopener"
			title="Upgrade"
		>
			Upgrade
		</a>
	</div>
</template>

<style lang="scss" scoped>
.upgrade-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    bottom: 0;
    height: 52px;
    width: 100%;
    z-index: 100;
    padding: 0 12px;
    font-family: Arial, Helvetica, sans-serif;
    background: #F1ECFF;
    border-top: 1px solid $color-primary;

    &__message {
        display: flex;
        align-items: center;
    }

    &__icon {
        margin-right: 4px;
    }

    &__text, &__link {
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        color: $color-dark;
    }

    &__link {
        color: $color-primary;
        text-decoration: none;
    }

    &__link-button {
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 82px;
        height: 28px;
        border-radius: 8px;
        text-decoration: none;
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
        color: #fff;
        background: $color-primary;
        transition: opacity 0.3s ease;

        &:hover {
            opacity: 0.9;
        }
    }
}
</style>
